import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMegaphone2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="megaphone-2, loud, speak, promote, feedback"><path d="M10 7.75H6C3.92893 7.75 2.25 9.42893 2.25 11.5C2.25 13.5711 3.92893 15.25 6 15.25H10" stroke="currentColor" strokeWidth="1.5"/><path d="M18 8.75H19C20.5188 8.75 21.75 9.98122 21.75 11.5C21.75 13.0188 20.5188 14.25 19 14.25H18" stroke="currentColor" strokeWidth="1.5"/><path d="M18.25 3.75L10 7.75V15.25L18.25 19.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M11.5 16.25V21.25H7.75V15.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMegaphone2;
